/*
 *
 * Merchant action types
 *
 */

// DOCUMENT UPLOAD ACTION TYPES
export const FETCH_SUBMITTED_DOC_LIST_INITIATED = 'FETCH_SUBMITTED_DOC_LIST_INITIATED';
export const FETCH_SUBMITTED_DOC_LIST_SUCCESS = 'FETCH_SUBMITTED_DOC_LIST_SUCCESS';
export const FETCH_SUBMITTED_DOC_LIST_FAILURE = 'FETCH_SUBMITTED_DOC_LIST_FAILURE';

export const UPLOAD_DOCUMENT_INITIATED = 'UPLOAD_DOCUMENT_INITIATED';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_FAILED = 'UPLOAD_DOCUMENT_FAILED';

export const REMOVE_DOCUMENT_INITIATED = 'REMOVE_DOCUMENT_INITIATED';
export const REMOVE_DOCUMENT_SUCCESS = 'REMOVE_DOCUMENT_SUCCESS';
export const REMOVE_DOCUMENT_FAILED = 'REMOVE_DOCUMENT_FAILED';

export const SUBMIT_DOCUMENTS_INITIATED = 'SUBMIT_DOCUMENTS_INITIATED';
export const SUBMIT_DOCUMENTS_SUCCESS = 'SUBMIT_DOCUMENTS_SUCCESS';
export const SUBMIT_DOCUMENTS_FAILED = 'SUBMIT_DOCUMENTS_FAILED';

export const FETCH_DOCUMENT_CATEGORY_AND_TYPES_INITIATED = 'FETCH_DOCUMENT_CATEGORY_AND_TYPES_INITIATED';
export const FETCH_DOCUMENT_CATEGORY_AND_TYPES_SUCCESS = 'FETCH_DOCUMENT_CATEGORY_AND_TYPES_SUCCESS';
export const FETCH_DOCUMENT_CATEGORY_AND_TYPES_FAILURE = 'FETCH_DOCUMENT_CATEGORY_AND_TYPES_FAILURE';

export const REFER_BULK_INITIATED = 'REFER_BULK_INITIATED';
export const REFER_BULK_SUCCESS = 'REFER_BULK_SUCCESS';
export const REFER_BULK_FAILED = 'REFER_BULK_FAILED';

export const REMOVE_BULK_INITIATED = 'REMOVE_BULK_INITIATED';
export const REMOVE_BULK_SUCCESS = 'REMOVE_BULK_SUCCESS';
export const REMOVE_BULK_FAILED = 'REMOVE_BULK_FAILED';


export const UPDATE_BULK_INITIATED = 'UPDATE_BULK_INITIATED';
export const UPDATE_BULK_SUCCESS = 'UPDATE_BULK_SUCCESS';
export const UPDATE_BULK_FAILED = 'UPDATE_BULK_FAILED';
export const UPLOAD_ICON_INITIATED = 'UPLOAD_ICON_INITIATED';
export const UPLOAD_ICON_SUCCESS = 'UPLOAD_ICON_SUCCESS';
export const UPLOAD_ICON_FAILURE = 'UPLOAD_ICON_FAILURE';
export const REMOVE_ICON_INITIATED = 'REMOVE_ICON_INITIATED';
export const REMOVE_ICON_SUCCESS = 'REMOVE_ICON_SUCCESS';
export const REMOVE_ICON_FAILURE = 'REMOVE_ICON_FAILURE';
export const BRANDING_DETAILS_INITIATED = 'BRANDING_DETAILS_INITIATED';
export const BRANDING_DETAILS_SUCCESS = 'BRANDING_DETAILS_SUCCESS';
export const BRANDING_DETAILS_FAILURE = 'BRANDING_DETAILS_FAILURE';

export const APPLICATION_DETAILS_INITIATED = 'APPLICATION_DETAILS_INITIATED';
export const APPLICATION_DETAILS_SUCCESS = 'APPLICATION_DETAILS_SUCCESS';
export const APPLICATION_DETAILS_FAILURE = 'APPLICATION_DETAILS_FAILURE';

export const SEND_OTP_INITIATED = 'SEND_OTP_INITIATED';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILED = 'SEND_OTP_FAILED';

export const VERIFY_OTP_INITIATED = 'VERIFY_OTP_INITIATED';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILED = 'VERIFY_OTP_FAILED';

export const DOWNLOAD_AGREEMENT_INITIATED = 'DOWNLOAD_AGREEMENT_INITIATED';
export const DOWNLOAD_AGREEMENT_SUCCESS = 'DOWNLOAD_AGREEMENT_SUCCESS';
export const DOWNLOAD_AGREEMENT_FAILED = 'DOWNLOAD_AGREEMENT_FAILED';

export const CLEAR_VERIFY_STATE = 'CLEAR_VERIFY_STATE';
